import React from "react";
import {type LoaderContextValue} from "../types/logic";

const {Provider, Consumer} = React.createContext<LoaderContextValue>({
  setLoader: undefined,
  removeLoader: undefined,
});



export const LoaderProvider = Provider;
export const LoaderConsumer = Consumer;

export function loaderHOC<P extends object>(Target: React.ComponentType<P & LoaderContextValue>) {
  const hoc = (props: React.PropsWithChildren<P>) => {
    return (<Consumer>
      {(contextValue) => (<Target {...props} {...contextValue} >{props.children}</Target>)}
    </Consumer>);
  };
  hoc.displayName = "LoaderHOC<>";
  return hoc;
}
